import { Structure } from "../../../db_access/structure";
import OrganizationalComparison from "../../../organizational-pages/OrganizationalComparison";

const StructureComparison = () => {
  return <OrganizationalComparison Org={Structure} />;
};

export default StructureComparison;
